<template>
  <!-- Qui andiamo a proporre tutti i messaggi che l'utente ha ricevuto pescandoli -->
  <!-- dalla chain dei messaggi -->
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_assistenza']"/>

    <!-- BOTTONE PER APRIRE LA MODALE CON LA TABELLA DEI MESSAGGI ARCHIVIATI -->
    <b-button variant="primary" size="sm" class="mb-3 ml-1" @click='show_archive = true'>
      <b-icon icon="archive-fill" font-scale="1" class="mr-1" ></b-icon> Non trovi i messaggi più vecchi? Consulta l'archivio
    </b-button>

    <!-- TABELLA DELLE NOTIFICHE RICEVUTE -->
    <!-- Per ora non visualizziamo i destinatari dei messaggi per privacy -->
    <!-- vediamo poi se questa cosa è ok -->
    <TabellaNotifiche :mode="'ricevuti'" :table_title="'Notifiche Welfarebit'" :show_dest="false" :archive="false"/>

    <!-- MODALE PER VISUALIZZARE I MESSAGGI ARCHIVIATI -->
    <!-- Apre la tabela delle notifiche ma questa volta in modalità archivio -->
    <!-- così che l'utente può andare a visualizzare i suoi messaggi che ora -->
    <!-- si trovano nel database dia rchivio Welfarebit -->
    <b-modal v-model='show_archive' size="xl" hide-header scrollable>
      <TabellaNotifiche :mode="'ricevuti'" :table_title="archive_title" :show_dest="false" :archive="true"/>
      <template v-slot:modal-footer="{ cancel }">
          <b-button variant="primary" size="sm" class="float-right" @click="cancel()">Chiudi</b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'
import TabellaNotifiche from '@/components/TabellaNotifiche'

export default {
  name: 'NotificheWb',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Notifiche Welfarebit", link : 'notifichewb' } ],

      // Variabile che ci dice se dobbiamo mostrare la modale con la tabella dei messaggi in archivio
      show_archive : false,

      // Titolo dela modale in modalità archivio, lo definiamo qui essendo u pò lungo.
      archive_title : "Archivio Notifiche - Ricerca tra i messaggi ricevuti in passato non più disponibili nella casella principale."
    }
  },
  components : {
      PageTagline,
      TutorialContestuale,
      TabellaNotifiche
  }
}
</script>



<style scoped></style>